module.exports = __webpack_public_path__ + "static/media/replace_sprint_response.c5b1a4c6.png";